export const SubtitleRow = ({ title, click = null }) => {
  return (
    <div
      className={
        "subtitle-row" + (click ? " clickable" : "")
      }
      onClick={click}
    >
      <hr />
      <h2>
        {click && <span>&#8643;&nbsp;</span>}
        {title}
        {click && <span>&nbsp;&#8642;</span>}
      </h2>
    </div>
  );
};
